<template>
    <v-stepper vertical alt-labels height="83" :class="['stepper-container', {'mobile': isMobile}]" dark flat
               v-model="currentStep">
        <v-stepper-header>
            <template v-for="(step, i) in steps">
                <v-stepper-step :complete="currentStep > step.value" :step="stepValue(step.value)">
                    <v-img v-if="currentStep === step.value" class="triangle-down-img"
                           :src="require('@/assets/icons/triangle_down_white.png')" width="20"/>
                    {{ step.name }}
                </v-stepper-step>
                <v-divider v-if="i < steps.length - 1" :class="dividerClass(i + 1)"/>
            </template>
        </v-stepper-header>
    </v-stepper>
</template>

<script>
export default {
    name: "StepperToolbar",
    props: {
        currentStep: {
            type: [Number, String],
            default: 1,
        },
        noRegister: {
            type: Boolean,
            default: false,
        },
        noSlug: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        steps(vm = this) {
            if (vm.noSlug) return [
                {name: 'Tus conexiones', value: 1},
                {name: 'Tu perfil médico', value: 2},
                {name: 'Examenes', value: 3},
                {name: 'Resumen', value: 4},
            ]
            if (vm.noRegister) return [
                {name: 'Tu perfil médico', value: 2},
                {name: 'Examenes', value: 3},
                {name: 'Resumen', value: 4},
            ]
            return [
                {name: 'Registro', value: 1},
                {name: 'Tu perfil médico', value: 2},
                {name: 'Examenes', value: 3},
                {name: 'Resumen', value: 4},
            ]
        }
    },
    methods: {
        dividerClass(index) {
            const vm = this
            if (index + 1 >= vm.currentStep) return 'divider-white'
            return 'divider-secondary'
        },
        stepValue(step) {
            const vm = this
            return vm.noRegister && !vm.noSlug ? step - 1 : step
        }
    }
}
</script>

<style scoped>

.stepper-container {
    background: #273866 !important;
    border-radius: 0 0 10px 10px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    position: sticky;
    top: 81px;
    z-index: 9;
}

.mobile {
    top: 60px;
    font-size: 9px;
}

.v-stepper__step {
    flex-basis: 120px !important;
}

>>> .v-stepper__step__step {
    background: #273866 !important;
    border: 2px solid #FFFFFF !important;
    margin-right: 0 !important;
}

>>> .v-stepper__step--complete > .v-stepper__step__step {
    background: var(--v-secondary-base) !important;
    border: 2px solid var(--v-secondary-base) !important;
}

.triangle-down-img {
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translate(-50%, 0);
}

::v-deep .v-stepper__label {
    text-align: center !important;
    margin-top: -4px;
}

</style>